<template>
  <div class="m-page m-p2">
    <svg class="income-icon" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 71.5 40.5">
      <g>
        <path fill="#53C27C" d="M9.5,11c0-1.9-1.2-3.1-4.1-3.7C3.1,6.8,2.9,6.2,2.9,5.6c0-0.7,0.7-1.3,1.9-1.3 c1.1,0,2.1,0.4,2.9,1.1L8,5.7l1.3-1.8L8.9,3.6C8.1,2.8,7,2.3,5.8,2.1V0.7C6,0.4,5.6,0,5.1,0H4.4C4,0,3.7,0.3,3.7,0.7v1.6 C2,2.5,0.6,4,0.6,5.7c0,2.5,2,3.2,4.2,3.7c2.3,0.5,2.5,1,2.5,1.7c0,0.8-0.8,1.4-1.9,1.4c-1.3,0-2.5-0.5-3.5-1.4l-0.5-0.4L0,12.4 l0.4,0.4c0.9,0.9,2.1,1.5,3.3,1.8v1.7c0,0.4,0.3,0.7,0.7,0.7h0.7c0.4,0,0.7-0.3,0.7-0.7v-1.5C8.1,14.4,9.5,13,9.5,11z" transform="translate(54.847 5.962)"/>
      </g>
      <path fill="#4F5661" d="M70.3,0H1.2C0.6,0,0,0.4,0,1.1c0,0,0,0.1,0,0.1v27.4c0,0.3,0.1,0.6,0.4,0.8l10.7,10.7	c0.2,0.2,0.5,0.4,0.8,0.4h58.4c0.6,0,1.2-0.4,1.2-1.1c0,0,0-0.1,0-0.1V1.2c0-0.6-0.4-1.2-1.1-1.2C70.4,0,70.4,0,70.3,0z M2.9,28.6	h9.1v9.1L2.9,28.6z M69.2,38.2H14.3V27.4c0-0.6-0.4-1.2-1.1-1.2c0,0-0.1,0-0.1,0H2.4V2.4h66.8V38.2z"/>
      <g>
        <path fill="#4F5661" d="M42.9,2.4H1.2C0.5,2.4,0,1.9,0,1.2S0.5,0,1.2,0h41.7c0.7,0,1.2,0.5,1.2,1.2 S43.6,2.4,42.9,2.4z" transform="translate(7.154 16.693)"/>
      </g>
      <g>
        <path fill="#4F5661" d="M29.8,2.4H1.2C0.5,2.4,0,1.9,0,1.2C0,0.5,0.5,0,1.2,0h28.6C30.5,0,31,0.5,31,1.2 C31,1.9,30.5,2.4,29.8,2.4z" transform="translate(19.077 31)"/>
      </g>
      <g>
        <path fill="#53C27C" d="M9.2,7.1C8.7,7.2,8.2,7,7.8,6.8C6.4,6,6.3,4,6.3,2.5c-1.6,0.8-3,2-4.2,3.5 C1.7,6.5,1,6.6,0.4,6.2C-0.1,5.8-0.2,5,0.2,4.5l0,0c1.7-2.1,5.1-5.1,7.2-4.4c0.8,0.2,1.4,1,1.3,1.9c0,0.6,0,2.5,0.4,2.7 c0.6,0,1.2-0.1,1.7-0.5c0.9-0.5,1.7-1,2.5-1.7c1.3-1,2.3-1.5,3.2-1.1c1.1,0.5,1.1,1.9,1.1,2.6v0.5c0.6-0.2,1.2-0.5,1.8-0.8 C19.8,3.6,20.4,3.2,21,3c0.6-0.3,1.3,0,1.5,0.6s0,1.3-0.6,1.5l-1.4,0.7c-1.5,0.7-3,1.5-4.2,0.7c-0.8-0.6-1.2-1.6-1.1-2.6l0,0 C15,4,14.9,4.2,14.6,4.3c-0.7,0.5-1.7,1.1-2.7,1.8C11.1,6.7,10.2,7.1,9.2,7.1z" transform="translate(22.685 22.665)"/>
      </g>
      <g>
        <path fill="#4F5661" d="M10.7,2.4H1.2C0.5,2.4,0,1.9,0,1.2C0,0.5,0.5,0,1.2,0h9.5c0.7,0,1.2,0.5,1.2,1.2 C11.9,1.9,11.4,2.4,10.7,2.4z" transform="translate(53.655 31)"/>
      </g>
      <g>
        <path fill="#CFE6F0" d="M3.6,8.4C3,8.4,2.4,7.9,2.4,7.3c0,0,0-0.1,0-0.1V3.1L1.7,3.5c-0.6,0.2-1.3,0-1.6-0.6 c-0.3-0.6-0.1-1.2,0.5-1.5c0,0,0,0,0,0L3,0.1C3.4,0,3.8,0,4.2,0.1c0.4,0.2,0.6,0.6,0.6,1.1v6c0,0.6-0.4,1.2-1.1,1.2 C3.7,8.4,3.6,8.4,3.6,8.4z" transform="translate(8.32 7.136)"/>
      </g>
      <g>
        <path fill="#CFE6F0" d="M3.6,8.3H2.4C1.1,8.3,0,7.3,0,6V2.4C0,1.1,1.1,0,2.4,0h1.2C4.9,0,6,1.1,6,2.4V6 C6,7.3,4.9,8.3,3.6,8.3z M2.4,2.4V6h1.2V2.4H2.4z" transform="translate(14.308 7.154)"/>
      </g>
      <g>
        <path fill="#CFE6F0" d="M3.6,8.3H2.4C1.1,8.3,0,7.3,0,6V2.4C0,1.1,1.1,0,2.4,0h1.2C4.9,0,6,1.1,6,2.4V6 C6,7.3,4.9,8.3,3.6,8.3z M2.4,2.4V6h1.2V2.4H2.4z" transform="translate(21.462 7.154)"/>
      </g>
      <g>
        <path fill="#CFE6F0" d="M3.6,8.3H2.4C1.1,8.3,0,7.3,0,6V2.4C0,1.1,1.1,0,2.4,0h1.2C4.9,0,6,1.1,6,2.4V6 C6,7.3,4.9,8.3,3.6,8.3z M2.4,2.4V6h1.2V2.4H2.4z" transform="translate(29.808 7.154)"/>
      </g>
      <g>
        <path fill="#CFE6F0" d="M3.6,8.3H2.4C1.1,8.3,0,7.3,0,6V2.4C0,1.1,1.1,0,2.4,0h1.2C4.9,0,6,1.1,6,2.4V6 C6,7.3,4.9,8.3,3.6,8.3z M2.4,2.4V6h1.2V2.4H2.4z" transform="translate(36.962 7.154)"/>
      </g>
      <g>
        <path fill="#CFE6F0" d="M3.6,8.3H2.4C1.1,8.3,0,7.3,0,6V2.4C0,1.1,1.1,0,2.4,0h1.2C4.9,0,6,1.1,6,2.4V6 C6,7.3,4.9,8.3,3.6,8.3z M2.4,2.4V6h1.2V2.4H2.4z" transform="translate(44.116 7.154)"/>
      </g>
    </svg>
    <h2>Adjusted Gross Income*</h2>
    <p>Enter your adjusted gross income.</p>
    <p class="asterisk">*Adjusted gross income is gross income minus adjustments like the student loan interest deduction or IRA deduction</p>
    <div class="m-p2__input-container">
      <vue-numeric class="m-p2__input" v-model="adjustedGrossIncome" currency="$" separator="," :precision="2" :max="999999999" placeholder="$0.00" @focus.native="$event.target.select()" @click.native="$event.target.setSelectionRange(0,9999)" @blur="validate" @input="updateStore('adjustedGrossIncome', adjustedGrossIncome, '2')"></vue-numeric>
      <transition name="fade">
        <div v-if="showErrorMessage" class="validation-message-2">Please enter your adjusted gross income.</div>
      </transition>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueNumeric from 'vue-numeric'
import { updateStore } from './mixins/updateStore'
import Vue2Filters from 'vue2-filters'

Vue.use(Vue2Filters)

export default {
  mounted () {
    this.adjustedGrossIncome = this.$store.state.adjustedGrossIncome
  },
  name: 'Page2',
  components: {
    VueNumeric
  },
  props: ['showErrorMessage'],
  mixins: [updateStore],
  data () {
    return {
      adjustedGrossIncome: 0
    }
  },
  methods: {
    validate () {
      this.$emit('validated', this.$store.state.indexUI)
      this.$store.commit('SET_VALID', '2')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../scss/vars';
.m-p2 {
  p.asterisk {
    font-family: $fPrimary;
    font-size: 10px;
    max-width: 310px;
    line-height: 1.3;
  }
  .validation-message-2 {
    font-family: $fPrimary;
    font-size: 14px;
    font-weight: $fMed;
    background: $cError;
    color: $cWhite;
    position: absolute;
    bottom: -40px;
    padding: 10px;
    border-radius: 4px;
    left: 0;
    right: 0;
    width: 100%;
    max-width: 378px;
    margin: 0 auto;
  }
  .income-icon {
    width: 72px;
    height: 41px;
    margin-bottom: 20px;
  }
  &__input-container {
    width: 100%;
    position: relative;
  }
  &__input {
    height: 50px;
    width: 100%;
    max-width: 378px;
    margin: 0 auto 0;
    display: block;
    font-family: $fPrimary;
    font-size: 14px;
    font-weight: $fReg;
    line-height: 20px;
    padding-left: 18px;
    padding-right: 18px;
    border-radius: 4px;
    border: 1px solid $cGray;
    &::placeholder {
      color: $cGray;
    }
  }
}
</style>
